var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.461,
    height: 16,
    viewBox: "0 0 13.461 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "write",
    transform: "translate(-7.875 0.025)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139578",
    "data-name": "Path 139578",
    d: "M9.494,13.445A1.137,1.137,0,0,0,9.83,13.4l2.879-.576a1.852,1.852,0,0,0,.848-.464l6.974-6.973a2.868,2.868,0,0,0,0-3.982L19.94.779a2.889,2.889,0,0,0-4,0L8.966,7.767a1.921,1.921,0,0,0-.464.848l-.608,2.911a1.628,1.628,0,0,0,1.6,1.919Zm.544-4.526L17.012,1.93a1.286,1.286,0,0,1,1.76,0l.608.608a1.24,1.24,0,0,1,0,1.839l-6.958,6.989-2.959.5Z",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139579",
    "data-name": "Path 139579",
    d: "M20.573,90.4H8.768A.723.723,0,0,0,8,91.169a.768.768,0,0,0,.768.769H20.509a.771.771,0,1,0,.064-1.537Z",
    transform: "translate(-0.105 -75.963)",
    fill: "#0b3454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.99ff9233a204df8b1a9b9be30fdd78c8.svg";
export { ForwardRef as ReactComponent };